import React, { useContext, useMemo, useRef } from 'react'

import { BrandLogo } from '@Components/Product/BrandLogo'
import { ProductContext } from '@Components/Product/Context'
import { getGalleryAssets } from '@Components/Product/Display/Helpers/GalleryAssets'
import { Info } from '@Components/Product/Display/Info'
import ProductSliders from '@Components/Product/Display/ProductSliders'
import { InfoWrapperV2, LayoutV2 } from '@Components/Product/Display/styledElements'
import SliderProvider from '@Components/Product/Slider'

const DisplayV2 = () => {
  const product = useContext(ProductContext)
  const assets = useMemo(() => getGalleryAssets(product), [product])
  const scrollToRef = useRef<HTMLDivElement>(null)

  if (!product) {
    return null
  }

  return (
    <LayoutV2>
      <SliderProvider slides={assets}>
        <ProductSliders ref={scrollToRef} />
      </SliderProvider>
      <InfoWrapperV2>
        {product.brand && <BrandLogo brand={product.brand} />}
        <Info reviewWrapperRef={scrollToRef} />
      </InfoWrapperV2>
    </LayoutV2>
  )
}

export default DisplayV2
